<script>
  import { onMount } from "svelte";
  import Quill from "quill";

  let Font = Quill.import("formats/font");
  Font.whitelist = ["inconsolata", "roboto", "poppins", "cinzel", "mirza", "arial"];
  Quill.register(Font, true);

  export let content;
  export let debug = false;

  let container;
  let editor;

  $: if (editor) {
    editor.setContents(content, "api");
  }

  const Link = Quill.import("formats/link");
  class MyLink extends Link {
    static create(value) {
      let node = super.create(value);
      value = this.sanitize(value);
      node.setAttribute("href", value);
      if (
        value.startsWith("https://mariage-parfait.com") ||
        value.startsWith("http://localhost") ||
        value.startsWith("#")
      ) {
        node.removeAttribute("target");
      }
      return node;
    }
  }

  Quill.register(MyLink, true);

  onMount(() => {
    let options = {
      debug: debug ? "info" : "warn",
      modules: {},
      readOnly: true,
    };
    editor = new Quill(container, options);
  });
</script>

<div class="container readOnly ql-snow">
  <div bind:this={container} />
</div>

<style>
  .container {
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .container :global(.readOnly .ql-editor) {
    padding: 0;
  }

  :global(.ql-container) {
    font-family: "Poppins";
    font-size: 16px;
  }
  /* Set content font-families */
  .container.ql-snow :global(.ql-font-mirza) {
    font-family: "Mirza";
  }
  .container.ql-snow :global(.ql-font-roboto) {
    font-family: "Roboto";
  }
  .container.ql-snow :global(.ql-font-arial) {
    font-family: "Arial";
  }
  .container.ql-snow :global(.ql-font-poppins) {
    font-family: "Poppins";
  }
  .container.ql-snow :global(.ql-font-cinzel) {
    font-family: "Cinzel";
  }
  .container.ql-snow :global(.ql-font-arial) {
    font-family: "Arial";
  }

  .container.ql-snow :global(iframe.ql-video) {
    display: block;
    max-width: 800px;
    /*width: 100%;*/
    width: -webkit-fill-available;
    min-height: 360px;
  }
</style>
